import React from 'react'
import { estimated } from './AL00000Sprint00'
import { getModuleDescription } from '../DataAndAPIs/ClassSections'
import { capstoneSprint7Link } from '../Activities/ClassProduct'
import { sprintEndDateWithoutTime } from '../CalendarAndSchedule/SprintDates'

import { getClassSectionID } from '../DataAndAPIs/ClassSections'
import { scheduleLinkV2 } from '../DataAndAPIs/Links'

import { getFinalExamDateAndTime } from '../DataAndAPIs/ClassSections'
import { classProductPresentationLink } from '../Activities/ClassProduct'

export const al49200Sprint07 = () => {
	const sprint = 7
	return ( <div>	
		<h5>Sprint {sprint}: {getModuleDescription(sprint-1)}</h5>
		<p>Stay focused on delivering stories that add the most value for customers, and always remember that being 
		“done” with something small and delivering it to production is <em>immensely</em> more valuable than being 
		“almost done” with something great.</p>

		<p>Also, be certain that all product assets are transitioned to the team that will develop the product going 
		forward. They are your legacy. Do they have everything the need to make the product successful?</p>

		<p>Our Learning Objectives for this sprint include:</p>
		<ul style={{listStyleType:'square'}}>
			<li>Master sprint planning by successfully completing sprint {sprint} planning within the first three days 
				of the sprint</li>
			<li>Master delivering valuable working code to the production environment</li>
			<li>Fully transition responsibility and ownership of the product to the team that will continue working on 
				it going forward</li>
		</ul>

		{list49200Sprint07(sprint)}
	</div> )
}

export const list49200Sprint07 = (sprint) => {
	return ( <div>
		<p>Below is our activities list which, according to our {scheduleLinkV2(getClassSectionID(), sprint)}, needs to be 
		completed by {sprintEndDateWithoutTime(sprint-1)}:</p>
		<ol>
			<li>Verify that you will attend in person and deliver your <em>{classProductPresentationLink()} on {getFinalExamDateAndTime()}</em></li>
			<li>Complete {capstoneSprint7Link()} Requirements 0, 1, and 2 and submit <u>Lab {sprint} - Planning</u></li>
			<li>Submit your initial Discussion post by the middle of the sprint</li>
			<li>Complete {capstoneSprint7Link()} {estimated('14 hours per team member')}</li>
			<li>Submit Discussion, Writing Assignment, Lab, and Reflection</li>
		</ol>
	</div> )
}

// Certified for SP25 on April 17, 2025
// Todo: Remove presentation requirement about referencing a story. It did not work well.
